import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import { useGlobalContext } from "../Context";
import { replaceVerbiage } from "../../utils/replaceVerbiage";
var alignItems = function (align, initial) {
    if (initial === void 0) { initial = 'center'; }
    var property = align || initial;
    switch (property) {
        case 'left':
            return 'flex-start';
        case 'right':
            return 'flex-end';
        case 'center':
            return 'center';
        default:
            return initial;
    }
};
var useStyles = createUseStyles(function (theme) {
    var _a, _b;
    return ({
        root: {
            backgroundColor: function (props) {
                return props.backgroundColor;
            },
            display: "block",
            overflow: "hidden",
            position: "relative",
            margin: "0 auto",
            width: "100%",
        },
        dropCap: {
            "& p": {
                "&:first-of-type": {
                    "&:first-letter": {
                        fontSize: 70,
                        float: "left",
                        marginTop: ".25em",
                        marginRight: ".3rem",
                    },
                },
            }
        },
        content: {
            textAlign: function (props) { return (props.align) ? props.align : 'left'; },
            "& p": {
                marginBottom: 44,
            },
            "& h1": {
                fontSize: theme.typography.title.fontSize,
                marginBottom: 44,
            },
            "& h2": {
                fontSize: theme.typography.heading2.fontSize,
                marginBottom: 44,
            },
            "& h3": {
                fontSize: theme.typography.heading3.fontSize,
                marginBottom: 44,
            }
        },
        container: (_a = {
                backgroundColor: function (props) {
                    return props.backgroundColor;
                },
                alignItems: function (props) { return alignItems(props.align, "center"); },
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                padding: "60px 40px",
                position: "relative",
                textAlign: "center",
                justifyContent: "center",
                fontSize: 32,
                lineHeight: "1.2",
                maxWidth: theme.maxWidth,
                margin: "0 auto",
                color: function (props) { return props.textColor; }
            },
            _a[theme.mediaQuery(theme.breakpoints.small)] = {
                padding: "80px 90px",
            },
            _a[theme.mediaQuery(theme.breakpoints.medium)] = {
                padding: "120px 240px",
            },
            _a),
        asurionRoot: (_b = {
                display: "flex",
                flexDirection: "column",
                alignItems: function (props) { return alignItems(props.align, "flex-start"); },
                margin: "0 auto",
                maxWidth: theme.maxWidth,
                width: "100%",
                overflow: "hidden",
                padding: "60px 40px",
                textAlign: "left",
                paddingBottom: 0,
                "& img": {
                    marginBottom: 24
                },
                "& p": {
                    marginBottom: 44,
                    fontSize: 26,
                    fontWeight: 400,
                    lineHeight: "125%",
                }
            },
            _b[theme.mediaQuery(theme.breakpoints.small)] = {
                padding: "80px 90px",
            },
            _b[theme.mediaQuery(theme.breakpoints.large)] = {
                padding: "120px 240px",
            },
            _b),
        longIntro: {
            fontSize: 24,
        },
    });
});
var isLongContent = function (content) {
    var cleanedText = content.replace(/<\/?[^>]+(>|$)/g, "");
    return cleanedText.length > 180;
};
var Intro = function (_a) {
    var _b, _c;
    var mainContent = _a.mainContent, backgroundColor = _a.backgroundColor, textColor = _a.textColor, iconImage = _a.iconImage, align = _a.align;
    var classes = useStyles({
        backgroundColor: backgroundColor,
        textColor: textColor,
        align: align
    });
    var vendor = useGlobalContext().vendor;
    var renderedContent = mainContent
        ? replaceVerbiage(mainContent, vendor)
        : "";
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classNames((_b = {},
                _b[classes.container] = vendor !== "asurion",
                _b[classes.asurionRoot] = vendor === "asurion",
                _b[classes.longIntro] = vendor !== "asurion" && mainContent && isLongContent(mainContent),
                _b)) },
            iconImage && (React.createElement("img", { "data-testid": "mobileImage", className: classes.styleIconImage, src: iconImage.fields.file.url || undefined, alt: "icon", role: "presentation" })),
            React.createElement("div", { className: classNames((_c = {}, _c[classes.content] = true, _c[classes.dropCap] = vendor === 'asurion' && (align === 'left' || align === undefined), _c)), dangerouslySetInnerHTML: {
                    __html: renderedContent,
                } }))));
};
Intro.defaultProps = {
    backgroundColor: "#f4f4f4",
    textColor: "#000",
    mainContent: "",
};
Intro.propTypes = {
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    mainContent: PropTypes.string,
};
export default Intro;
